import {createContext as $jWEGB$createContext, useContext as $jWEGB$useContext, useMemo as $jWEGB$useMemo, useCallback as $jWEGB$useCallback, useState as $jWEGB$useState, useEffect as $jWEGB$useEffect, useSyncExternalStore as $jWEGB$useSyncExternalStore, useRef as $jWEGB$useRef} from "react";
import $jWEGB$lodashisMatchWith from "lodash/isMatchWith";
import {jsx as $jWEGB$jsx} from "react/jsx-runtime";
import $jWEGB$lodashcloneDeep from "lodash/cloneDeep";
import $jWEGB$lodashmerge from "lodash/merge";


const $ea841572c05dff4f$export$da5dc9062cba6715 = {
    product: undefined,
    subproduct: undefined,
    locale: undefined,
    isSiteAdmin: undefined,
    tenantId: undefined,
    workspaceId: undefined,
    orgId: undefined
};
const $ea841572c05dff4f$export$a228be81fcb77b42 = (0, $jWEGB$createContext)($ea841572c05dff4f$export$da5dc9062cba6715);
const $ea841572c05dff4f$export$3a10495c2cd2db0c = $ea841572c05dff4f$export$a228be81fcb77b42.Provider;
const $ea841572c05dff4f$export$b77983be89bb0a4e = $ea841572c05dff4f$export$3a10495c2cd2db0c;
const $ea841572c05dff4f$export$5bd9099e0ae94a43 = ()=>(0, $jWEGB$useContext)($ea841572c05dff4f$export$a228be81fcb77b42);



const $1458487bfee865f2$export$6b9464f8de6868d6 = {
    env: 'local',
    api: {
        origin: undefined,
        pathname: undefined,
        searchParams: undefined
    },
    remoteModule: {
        origin: undefined,
        pathname: undefined,
        searchParams: undefined
    }
};
const $1458487bfee865f2$export$fceca2c399b32565 = (0, $jWEGB$createContext)($1458487bfee865f2$export$6b9464f8de6868d6);
const $1458487bfee865f2$export$604607f913ef367c = $1458487bfee865f2$export$fceca2c399b32565.Provider;
const $1458487bfee865f2$export$877b97169cc75e8b = ()=>(0, $jWEGB$useContext)($1458487bfee865f2$export$fceca2c399b32565);



function $53dce406bdd76ef4$export$cdf98ded28406f69(obj) {
    return Object.entries(obj).sort().flatMap((v)=>v);
}
function $53dce406bdd76ef4$export$ed02d4adf2068b08(obj) {
    return (0, $jWEGB$useMemo)(()=>obj, $53dce406bdd76ef4$export$cdf98ded28406f69(obj));
}








const $c47f95ca64ec1d34$export$98c77e1bd702ed15 = ({ routeSubscriber: routeSubscriber, initialUrl: initialUrl })=>{
    let state = $c47f95ca64ec1d34$var$initializeState({
        initialUrl: initialUrl
    });
    const handleUpdate = (routeChange)=>{
        const next = routeChange.next?.toString();
        if (next === state.current) return;
        state = {
            previous: state.current,
            current: next
        };
    };
    const subscribe = (next)=>routeSubscriber((routeChange)=>{
            handleUpdate(routeChange);
            next();
        });
    const getSnapshot = ()=>{
        return state;
    };
    return {
        subscribe: subscribe,
        getSnapshot: getSnapshot
    };
};
const $c47f95ca64ec1d34$var$usePostOfficeRouteStore = ({ subscribe: subscribe, getSnapshot: getSnapshot })=>{
    const route = (0, $jWEGB$useSyncExternalStore)(subscribe, getSnapshot);
    return (0, $53dce406bdd76ef4$export$ed02d4adf2068b08)(route);
};
const $c47f95ca64ec1d34$var$initialState = {
    previous: undefined,
    current: undefined
};
const $c47f95ca64ec1d34$var$initializeState = ({ initialUrl: initialUrl })=>({
        ...$c47f95ca64ec1d34$var$initialState,
        current: initialUrl ? initialUrl?.toString() : undefined
    });
const $c47f95ca64ec1d34$export$f7f47a74e8b47b1f = /*#__PURE__*/ (0, $jWEGB$createContext)($c47f95ca64ec1d34$var$initialState);
const $c47f95ca64ec1d34$export$89eadc6b3e5f4e9e = ({ children: children, ...props })=>{
    const ref = (0, $jWEGB$useRef)();
    if (!ref.current) ref.current = $c47f95ca64ec1d34$export$98c77e1bd702ed15(props);
    const route = $c47f95ca64ec1d34$var$usePostOfficeRouteStore(ref.current);
    return /*#__PURE__*/ (0, $jWEGB$jsx)($c47f95ca64ec1d34$export$f7f47a74e8b47b1f.Provider, {
        value: route,
        children: children
    });
};
const $c47f95ca64ec1d34$export$79301b66f7808cd8 = ()=>(0, $jWEGB$useContext)($c47f95ca64ec1d34$export$f7f47a74e8b47b1f); //Route listener


const $023c6d831230fd6d$export$92469b55607f005b = ()=>{
    const subscribers = new Map();
    const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    const publish = (payload)=>{
        subscribers.forEach((callback)=>callback(payload));
    };
    return [
        subscribe,
        publish
    ];
};


const $eced18ed793bdaab$export$daf66a67c26dc848 = (config)=>{
    const matchScopes = (0, $jWEGB$useCallback)($eced18ed793bdaab$export$ec890b48cae4cc1c(config), [
        config.scopes
    ]);
    const [state, setState] = (0, $jWEGB$useState)($eced18ed793bdaab$var$initialState);
    const route = (0, $c47f95ca64ec1d34$export$79301b66f7808cd8)();
    const context = (0, $ea841572c05dff4f$export$5bd9099e0ae94a43)();
    const next = matchScopes({
        route: route,
        context: context
    });
    $eced18ed793bdaab$var$usePostOfficeScopeSpy(state, config);
    (0, $jWEGB$useEffect)(()=>{
        if (!$eced18ed793bdaab$var$nextIsDifferent({
            next: next,
            state: state
        })) return;
        return setState({
            current: next,
            previous: state.current
        });
    }, [
        $eced18ed793bdaab$var$stringifyActiveScopes(next)
    ]);
    return state;
};
const $eced18ed793bdaab$var$initialState = {
    current: [],
    previous: []
};
const $eced18ed793bdaab$var$createMatchScope = ({ route: route, context: context })=>(input)=>{
        const contextMatch = route?.current ? {
            route: $eced18ed793bdaab$var$extractRelevantUrlFields(route.current),
            context: context
        } : {
            route: undefined,
            context: context
        };
        const inputMatch = input.when;
        return $eced18ed793bdaab$var$matchScope({
            contextMatch: contextMatch,
            inputMatch: inputMatch
        });
    };
const $eced18ed793bdaab$var$extractRelevantUrlFields = (route)=>{
    const { hostname: hostname, pathname: pathname } = new URL(route);
    return {
        hostname: hostname,
        pathname: pathname
    };
};
const $eced18ed793bdaab$var$matchScope = ({ contextMatch: contextMatch, inputMatch: inputMatch })=>(0, $jWEGB$lodashisMatchWith)(contextMatch, inputMatch, (contextValue, inputValue)=>$eced18ed793bdaab$var$isValueMatchDeep({
            contextValue: contextValue,
            inputValue: inputValue
        }));
const $eced18ed793bdaab$var$isValueMatch = ({ contextValue: contextValue, inputValue: inputValue })=>{
    if (!contextValue || !inputValue) return false;
    if (typeof inputValue === 'string') return contextValue === inputValue;
    if (inputValue?.equals) return contextValue === inputValue.equals;
    if (!inputValue?.matches) return false;
    if (typeof inputValue.matches !== 'string' || typeof contextValue !== 'string') return false;
    return new RegExp(inputValue.matches).test(contextValue);
};
const $eced18ed793bdaab$var$isValueMatchDeep = ({ contextValue: contextValue, inputValue: inputValue })=>typeof inputValue === 'object' && typeof contextValue === 'object' ? $eced18ed793bdaab$var$matchScope({
        contextMatch: contextValue,
        inputMatch: inputValue
    }) : $eced18ed793bdaab$var$isValueMatch({
        contextValue: contextValue,
        inputValue: inputValue
    });
const $eced18ed793bdaab$export$ec890b48cae4cc1c = ({ scopes: scopes })=>(input)=>scopes.filter($eced18ed793bdaab$var$createMatchScope(input)).map((scope)=>({
                name: scope.name
            }));
const $eced18ed793bdaab$var$nextIsDifferent = ({ next: next, state: state })=>{
    const currentSet = Array.from(new Set(state.current.map((e)=>e.name)));
    const nextSet = Array.from(new Set(next.map((e)=>e.name)));
    if (nextSet.length !== currentSet.length) return true;
    return !nextSet.every((e)=>currentSet.includes(e));
};
const $eced18ed793bdaab$var$stringifyActiveScopes = (scopes)=>JSON.stringify(scopes.map((e)=>e?.name));
// Scope Spy
const $eced18ed793bdaab$var$usePostOfficeScopeSpy = (state, config)=>{
    if (config?.consoleSpy && typeof window !== 'undefined' && !window?.postOffice?.scopes) {
        const [listen, update] = (0, $023c6d831230fd6d$export$92469b55607f005b)();
        window.postOffice = {
            ...window.postOffice,
            scopes: {
                [config?.consoleSpy.name]: {
                    listen: listen,
                    update: update,
                    list: config.scopes
                }
            }
        };
    }
    (0, $jWEGB$useEffect)(()=>{
        if (!config?.consoleSpy) return;
        if (!window.postOffice?.scopes) return;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        window.postOffice?.scopes?.[config?.consoleSpy.name]?.update?.(state);
    }, [
        $eced18ed793bdaab$var$stringifyActiveScopes(state.current)
    ]);
};




/**
 * Creates a Publish-Subscribe pattern for managing callbacks.
 * @returns {Array<Subscribe, Publish>} An array containing a Subscribe function and a Publish function.
 */ const $e93b37c9a81927d9$var$createPubSub = ()=>{
    const subscribers = new Map();
    /**
	 * Subscribes a callback function to the pub-sub system.
	 * @param {Callback} subscriber - The callback function to subscribe.
	 * @returns A function to unsubscribe the callback.
	 */ const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    /**
	 * Publishes the payload to all subscribed callbacks.
	 * @param {Callback} payload - The payload to publish to the subscribers.
	 */ const publish = (payload)=>{
        subscribers.forEach((cb)=>cb(payload));
    };
    return [
        subscribe,
        publish
    ];
};
const $e93b37c9a81927d9$export$a28a0c048b24fc5a = ()=>{
    const [onMessageDismiss, dismissMessageFromPlacement] = $e93b37c9a81927d9$var$createPubSub();
    const [onMessageRead, markReadFromPlacement] = $e93b37c9a81927d9$var$createPubSub();
    return {
        onMessageDismiss: /**
		 * Callback function for handling message dismiss.
		 * @param {Callback} callback - The callback function to be invoked on message dismiss.
		 */ onMessageDismiss,
        dismissMessageFromPlacement: /**
		 * Callback function to dismiss a message from placement.
		 * @type {Callback}
		 */ dismissMessageFromPlacement,
        onMessageRead: /**
		 * Callback function for handling message read.
		 * @param {Callback} callback - The callback function to be invoked on message read.
		 */ onMessageRead,
        markReadFromPlacement: /**
		 * Callback function to mark a message as read from placement.
		 * @type {Callback}
		 */ markReadFromPlacement
    };
};
const $e93b37c9a81927d9$export$ea58328f3ceee4d4 = /*#__PURE__*/ (0, $jWEGB$createContext)($e93b37c9a81927d9$export$a28a0c048b24fc5a());
const $e93b37c9a81927d9$export$c7535f8ebc5b75a9 = $e93b37c9a81927d9$export$ea58328f3ceee4d4.Provider;
const $e93b37c9a81927d9$export$c4b5cec0911af177 = ()=>({ children: children })=>/*#__PURE__*/ (0, $jWEGB$jsx)($e93b37c9a81927d9$export$c7535f8ebc5b75a9, {
            value: $e93b37c9a81927d9$export$a28a0c048b24fc5a(),
            children: children
        });
const $e93b37c9a81927d9$export$89f8e1f623d8f5ac = ()=>(0, $jWEGB$useContext)($e93b37c9a81927d9$export$ea58328f3ceee4d4);







// Api
const $bc22dec01f3b6f79$export$1e9fed4c0197724c = 'http://localhost:8001';
const $bc22dec01f3b6f79$export$919a9569bce66f17 = '';
const $bc22dec01f3b6f79$export$67be2569ef5d7666 = 'http://localhost:9009';
const $bc22dec01f3b6f79$export$b49738b89db261cd = 'https://post-office-rml-frontend.stg-east.frontend.public.atl-paas.net';
const $bc22dec01f3b6f79$export$bbd96cd490b0df63 = 'https://post-office-rml-frontend.prod-east.frontend.public.atl-paas.net';


const $4e9e60b627782936$export$cd77eeea2bda30f1 = (env)=>{
    const envs = {
        test: {
            env: 'test',
            remoteModule: {
                origin: (0, $bc22dec01f3b6f79$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $bc22dec01f3b6f79$export$1e9fed4c0197724c),
                pathname: (0, $bc22dec01f3b6f79$export$919a9569bce66f17),
                searchParams: undefined
            }
        },
        dev: {
            env: 'dev',
            remoteModule: {
                origin: (0, $bc22dec01f3b6f79$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $bc22dec01f3b6f79$export$1e9fed4c0197724c),
                pathname: (0, $bc22dec01f3b6f79$export$919a9569bce66f17),
                searchParams: undefined
            }
        },
        local: {
            env: 'local',
            remoteModule: {
                origin: (0, $bc22dec01f3b6f79$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: undefined,
                searchParams: undefined
            }
        },
        staging: {
            env: 'staging',
            remoteModule: {
                origin: (0, $bc22dec01f3b6f79$export$b49738b89db261cd),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: undefined,
                searchParams: undefined
            }
        },
        'stg-fedm-east': {
            env: 'stg-fedm-east',
            remoteModule: {
                origin: (0, $bc22dec01f3b6f79$export$b49738b89db261cd),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: undefined,
                searchParams: undefined
            }
        },
        production: {
            env: 'production',
            remoteModule: {
                origin: (0, $bc22dec01f3b6f79$export$bbd96cd490b0df63),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: undefined,
                searchParams: undefined
            }
        },
        'prod-fedm-east': {
            env: 'prod-fedm-east',
            remoteModule: {
                origin: (0, $bc22dec01f3b6f79$export$bbd96cd490b0df63),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: undefined,
                searchParams: undefined
            }
        }
    };
    return envs[env];
};








const $52f230cfcee9906f$var$noop = ()=>{};
const $52f230cfcee9906f$var$RouteListenerContext = /*#__PURE__*/ (0, $jWEGB$createContext)({
    update: $52f230cfcee9906f$var$noop
});
const $52f230cfcee9906f$export$7a2084f4baac29a7 = ()=>(0, $023c6d831230fd6d$export$92469b55607f005b)();
const $52f230cfcee9906f$export$72fd8977abf03d60 = ()=>(0, $jWEGB$useContext)($52f230cfcee9906f$var$RouteListenerContext);
const $52f230cfcee9906f$export$755edb1665399d41 = ()=>{
    const ref = (0, $jWEGB$useRef)();
    if (!ref.current) ref.current = $52f230cfcee9906f$export$7a2084f4baac29a7();
    const [routeSubscriber, updateRoute] = ref.current;
    const routeConfig = (0, $jWEGB$useMemo)(()=>({
            initialUrl: new URL(window.location.href),
            routeSubscriber: routeSubscriber
        }), [
        routeSubscriber
    ]);
    const routeUpdater = (0, $jWEGB$useMemo)(()=>({
            update: updateRoute
        }), [
        updateRoute
    ]);
    return [
        routeConfig,
        routeUpdater
    ];
};
const $52f230cfcee9906f$export$bb606326acdd1a64 = (deps)=>{
    const { update: update } = $52f230cfcee9906f$export$72fd8977abf03d60();
    (0, $jWEGB$useEffect)(()=>{
        if (typeof window === 'undefined') return;
        update({
            next: new URL(window.location.href)
        });
    }, deps);
};
const $52f230cfcee9906f$export$31986273b686f5ea = ({ children: children })=>{
    const [route, routeUpdater] = $52f230cfcee9906f$export$755edb1665399d41();
    return /*#__PURE__*/ (0, $jWEGB$jsx)($52f230cfcee9906f$var$RouteListenerContext.Provider, {
        value: routeUpdater,
        children: /*#__PURE__*/ (0, $jWEGB$jsx)((0, $c47f95ca64ec1d34$export$89eadc6b3e5f4e9e), {
            ...route,
            children: children
        })
    });
};



const $7bc7f9ab18ee7f6d$export$fb465b6e855c1e85 = ({ environment: environment, context: context, children: children })=>{
    const stableEnvironment = (0, $53dce406bdd76ef4$export$ed02d4adf2068b08)($7bc7f9ab18ee7f6d$var$composeConfig((0, $1458487bfee865f2$export$6b9464f8de6868d6), (0, $4e9e60b627782936$export$cd77eeea2bda30f1)(environment.env), environment.overrides));
    const stableContext = (0, $53dce406bdd76ef4$export$ed02d4adf2068b08)($7bc7f9ab18ee7f6d$var$composeConfig((0, $ea841572c05dff4f$export$da5dc9062cba6715), context.current));
    const memoizedMessagePlacementValues = (0, $jWEGB$useMemo)(()=>(0, $e93b37c9a81927d9$export$a28a0c048b24fc5a)(), []);
    return /*#__PURE__*/ (0, $jWEGB$jsx)((0, $1458487bfee865f2$export$604607f913ef367c), {
        value: stableEnvironment,
        children: /*#__PURE__*/ (0, $jWEGB$jsx)((0, $ea841572c05dff4f$export$3a10495c2cd2db0c), {
            value: stableContext,
            children: /*#__PURE__*/ (0, $jWEGB$jsx)((0, $e93b37c9a81927d9$export$c7535f8ebc5b75a9), {
                value: memoizedMessagePlacementValues,
                children: /*#__PURE__*/ (0, $jWEGB$jsx)((0, $52f230cfcee9906f$export$31986273b686f5ea), {
                    children: children
                })
            })
        })
    });
};
const $7bc7f9ab18ee7f6d$var$composeConfig = (base, ...rest)=>rest.reduce((a, v)=>(0, $jWEGB$lodashmerge)(a, v), (0, $jWEGB$lodashcloneDeep)(base));






export {$ea841572c05dff4f$export$5bd9099e0ae94a43 as usePostOfficeContext, $ea841572c05dff4f$export$a228be81fcb77b42 as PostOfficeContext, $ea841572c05dff4f$export$b77983be89bb0a4e as PostOfficeContextProvider, $1458487bfee865f2$export$877b97169cc75e8b as usePostOfficeEnvironment, $53dce406bdd76ef4$export$ed02d4adf2068b08 as useStableObject, $eced18ed793bdaab$export$daf66a67c26dc848 as useContextScope, $e93b37c9a81927d9$export$89f8e1f623d8f5ac as useMessagePlacementHooks, $7bc7f9ab18ee7f6d$export$fb465b6e855c1e85 as PostOfficeProvider, $52f230cfcee9906f$export$bb606326acdd1a64 as usePostOfficeRouteUpdate, $c47f95ca64ec1d34$export$f7f47a74e8b47b1f as PostOfficeRouteContext, $c47f95ca64ec1d34$export$79301b66f7808cd8 as usePostOfficeRoute, $1458487bfee865f2$export$604607f913ef367c as PostOfficeEnvironmentProvider};
//# sourceMappingURL=index.js.map
